// removed by extract-text-webpack-plugin
module.exports = {"content":"_3SkqT44o7g0rVvOURBXbzw","fadeIn":"_3o8toBZSb4tnePq_Ola30o"};


//////////////////
// WEBPACK FOOTER
// ../components/content-page/styles.module.css
// module id = 440
// module chunks = 0